import React, { useState } from 'react';
import './NavMobile.css';
import FireworksBefore from '../../Assets/Images/Petardos_hamburgesa.png';
import FireworksAfter from '../../Assets/Svg/Petardos_explotados.svg';
import Language from '../../Assets/Images/bandera-españa.png';
import LanguageV from '../../Assets/Images/bandera-valenciano.png';
import { Link } from 'react-router-dom';

export const NavMobile = (props) => {
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const onClick = (subMenuId) => {
        const subMenu = document.getElementById(subMenuId);
        const currentActiveSubMenu = document.getElementById(activeSubMenu);
        if (activeSubMenu && activeSubMenu !== subMenuId && currentActiveSubMenu) {
            currentActiveSubMenu.style.height = '0px';
        }

        if (!subMenu) return;

        if (!subMenu.clientHeight) {
            subMenu.style.height = `${subMenu.scrollHeight}px`;
            setActiveSubMenu(subMenuId);
        } else {
            subMenu.style.height = '0px';
            setActiveSubMenu(null);
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        if (!isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    };

    const handleOptionClick = (option) => {

        document.body.style.overflow = 'unset';

        if (option === "idioma") {
            if (localStorage.getItem("Language") === "Spanish") {
                localStorage.setItem("Language", "Valencian");
            } else {
                localStorage.setItem("Language", "Spanish");
            }
            window.location.reload();
        }
        setSelectedOption(option === selectedOption ? null : option);
    }


    return (
        <div className="nav-container">
            <img src={FireworksBefore} alt="Fireworks Before" className={`menu-toggle ${isMenuOpen ? 'hidden' : ''}`} onClick={toggleMenu} />
            <aside className={`sidebar ${isMenuOpen ? 'open' : ''}`}>
                <div className="menu-toggle" onClick={toggleMenu}>
                    <img src={FireworksAfter} alt="Menu Toggle" />
                </div>
                <ul>
                <li>
                    <span className='button-nav' type="button" onClick={() => onClick('fallerosSubMenu')} id="fallerosButton">
                        <Link 
                        to='/login'
                        onClick={() => handleOptionClick()}
                        >{props.I18n.Falleros}</Link>
                    </span>
                </li>
                <li>
                    <span className='button-nav' type="button" onClick={() => onClick('historicoSubMenu')} id="historicoButton">
                        <p>{props.I18n.Historical}</p>
                    </span>
                    <div className="sub-menu" id="historicoSubMenu">
                        <ul>
                            <li>
                                <Link
                                className='button-nav' 
                                
                                to="/nuestra-historia"
                                onClick={() => handleOptionClick()}
                                >{props.I18n.OurHistory}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to="/llibret"
                                onClick={() => handleOptionClick()}
                                >{props.I18n.Llibret}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to="/representantes-anteriores"
                                onClick={() => handleOptionClick()}
                                >{props.I18n.PreviousRepresentatives}</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <span className='button-nav'type="button" onClick={() => onClick('galeriaSubMenu')} id="galeriaButton">
                        <p>{props.I18n.Galery}</p>
                    </span>
                    <div className="sub-menu" id="galeriaSubMenu">
                        <ul>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/arte-fallero'
                                onClick={() => handleOptionClick()} 
                                >{props.I18n.FalleroArt}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/premios-y-reconocimientos'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.AwardsAndHonours}</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <span className='button-nav'type="button" onClick={() => onClick('ejercicioSubMenu')} id="ejercicioButton">
                        <p>{props.I18n.Exercise}</p>
                    </span>
                    <div className="sub-menu" id="ejercicioSubMenu">
                        <ul>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/representantes-actuales'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.CurrentRepresentatives}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/noticias'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.News}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/calendario-rodrigo'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.EventsCalendar}</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <span className='button-nav'type="button" onClick={() => onClick('nosotrosSubMenu')} id="nosotrosButton">
                        <p>{props.I18n.Us}</p>
                    </span>
                    <div className="sub-menu" id="nosotrosSubMenu">
                        <ul>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/formulario-de-contacto'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.ContactForm}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/patrocinadores'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.Sponsors}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/descargas'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.Downloads}</Link>
                            </li>
                            <li>
                                <Link 
                                className='button-nav'
                                type="button"
                                to='/canciones-rodrigueras'
                                onClick={() => handleOptionClick()}
                                >{props.I18n.RodriguerasSongs} </Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className={` ${selectedOption === 'idioma' ? 'selected' : ''}`}>
            <span className='button-nav' onClick={() => handleOptionClick('idioma')}>
              {
                localStorage.getItem("Language") === "Spanish" ? <img href="#" src={Language} alt='Language' /> : <img href="#" src={LanguageV} alt='Language' />
              }
            </span>
          </li>
                </ul>
            </aside>
        </div>
    );
};